import React from "react";
import {CssBaseline} from "@mui/material";
import {ThemeProvider} from "@mui/material/styles";
import theme from "./theme";
import ImageComp from "./Components/Image";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline/>
      <ImageComp/>
    </ThemeProvider>
  );
}

export default App;
